window.GreenBadgeZones = {
  "dataVersion": "29.09.2025",
  "source": "UBA/GIS Umweltzonen Deutschland; lokale WGS84-Stadtmittelpunkte für Entfernungsberechnung ergänzt",
  "zones": [
    {
      "name": "Ludwigsburg und Umgebung",
      "state": "Baden-Württemberg",
      "validFrom": "2013-01-01",
      "validFromDisplay": "01.01.2013",
      "aliases": [
        "Ludwigsburg",
        "Asperg",
        "Bietigheim-Bissingen",
        "Freiberg",
        "Freiberg am Neckar",
        "Ingersheim",
        "Kornwestheim",
        "Markgröningen",
        "Moeglingen",
        "Möglingen",
        "Pleidelsheim",
        "Remseck",
        "Remseck am Neckar",
        "Tamm"
      ],
      "type": "area",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "lat": 48.8975,
      "lng": 9.1919,
      "geoType": "region_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Pforzheim",
      "state": "Baden-Württemberg",
      "validFrom": "2013-01-01",
      "validFromDisplay": "01.01.2013",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 48.8922,
      "lng": 8.6946,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Stuttgart",
      "state": "Baden-Württemberg",
      "validFrom": "2012-01-01",
      "validFromDisplay": "01.01.2012",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [
        "Stoccarda"
      ],
      "type": "city",
      "lat": 48.7758,
      "lng": 9.1829,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Augsburg",
      "state": "Bayern",
      "validFrom": "2016-06-01",
      "validFromDisplay": "01.06.2016",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 48.3705,
      "lng": 10.8978,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "München",
      "state": "Bayern",
      "validFrom": "2012-10-01",
      "validFromDisplay": "01.10.2012",
      "aliases": [
        "Muenchen",
        "Munich",
        "Mnichov",
        "Monachium",
        "Monaco"
      ],
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "type": "city",
      "lat": 48.1372,
      "lng": 11.5756,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Regensburg",
      "state": "Bayern",
      "validFrom": "2018-01-15",
      "validFromDisplay": "15.01.2018",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 49.0134,
      "lng": 12.1016,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Berlin",
      "state": "Berlin",
      "validFrom": "2010-01-01",
      "validFromDisplay": "01.01.2010",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 52.52,
      "lng": 13.405,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Bremen",
      "state": "Bremen",
      "validFrom": "2011-07-01",
      "validFromDisplay": "01.07.2011",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 53.0793,
      "lng": 8.8017,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Darmstadt",
      "state": "Hessen",
      "validFrom": "2015-11-01",
      "validFromDisplay": "01.11.2015",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 49.8728,
      "lng": 8.6512,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Frankfurt a.M.",
      "state": "Hessen",
      "validFrom": "2012-01-01",
      "validFromDisplay": "01.01.2012",
      "aliases": [
        "Frankfurt",
        "Frankfurt am Main",
        "Frankfurt a M",
        "Frankfurt/Main"
      ],
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "type": "city",
      "lat": 50.1109,
      "lng": 8.6821,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Limburg an der Lahn",
      "state": "Hessen",
      "validFrom": "2018-01-31",
      "validFromDisplay": "31.01.2018",
      "aliases": [
        "Limburg"
      ],
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "type": "city",
      "lat": 50.3836,
      "lng": 8.0503,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Marburg (Zone Ost)",
      "state": "Hessen",
      "validFrom": "2016-04-01",
      "validFromDisplay": "01.04.2016",
      "aliases": [
        "Marburg",
        "Marburg Ost"
      ],
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "type": "city",
      "lat": 50.809,
      "lng": 8.7707,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze.",
      "nearbyKey": "marburg"
    },
    {
      "name": "Marburg (Zone West)",
      "state": "Hessen",
      "validFrom": "2016-04-01",
      "validFromDisplay": "01.04.2016",
      "aliases": [
        "Marburg",
        "Marburg West"
      ],
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "type": "city",
      "lat": 50.809,
      "lng": 8.7707,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze.",
      "nearbyKey": "marburg"
    },
    {
      "name": "Offenbach",
      "state": "Hessen",
      "validFrom": "2015-01-01",
      "validFromDisplay": "01.01.2015",
      "aliases": [
        "Offenbach am Main"
      ],
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "type": "city",
      "lat": 50.0956,
      "lng": 8.7761,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Wiesbaden",
      "state": "Hessen",
      "validFrom": "2013-02-01",
      "validFromDisplay": "01.02.2013",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 50.0782,
      "lng": 8.2398,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Osnabrück",
      "state": "Niedersachsen",
      "validFrom": "2012-01-03",
      "validFromDisplay": "03.01.2012",
      "aliases": [
        "Osnabrueck"
      ],
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "type": "city",
      "lat": 52.2799,
      "lng": 8.0472,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Aachen",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2016-02-01",
      "validFromDisplay": "01.02.2016",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 50.7753,
      "lng": 6.0839,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Bonn",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2014-07-01",
      "validFromDisplay": "01.07.2014",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 50.7374,
      "lng": 7.0982,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Dinslaken",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2012-10-01",
      "validFromDisplay": "01.10.2012",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 51.5623,
      "lng": 6.743,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Düsseldorf",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2014-07-01",
      "validFromDisplay": "01.07.2014",
      "aliases": [
        "Duesseldorf",
        "Dusseldorf"
      ],
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "type": "city",
      "lat": 51.2277,
      "lng": 6.7735,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Eschweiler",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2016-06-01",
      "validFromDisplay": "01.06.2016",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 50.8185,
      "lng": 6.2718,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Hagen",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2014-07-01",
      "validFromDisplay": "01.07.2014",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 51.3671,
      "lng": 7.4633,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Krefeld",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2012-07-01",
      "validFromDisplay": "01.07.2012",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 51.3388,
      "lng": 6.5853,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Köln",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2014-07-01",
      "validFromDisplay": "01.07.2014",
      "aliases": [
        "Koeln",
        "Cologne",
        "Keulen",
        "Kolonia",
        "Kolín nad Rýnem",
        "Kolin nad Rynem",
        "Colonia"
      ],
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "type": "city",
      "lat": 50.9375,
      "lng": 6.9603,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze.",
      "nearbyKey": "koeln"
    },
    {
      "name": "Köln (Erweiterung 2019)",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2019-01-01",
      "validFromDisplay": "01.01.2019",
      "aliases": [
        "Köln",
        "Koeln",
        "Cologne",
        "Köln Erweiterung",
        "Koeln Erweiterung",
        "Cologne extension",
        "Keulen",
        "Kolonia",
        "Kolín nad Rýnem",
        "Kolin nad Rynem",
        "Colonia"
      ],
      "note": "Erweiterung der Umweltzone 2019.",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "type": "city",
      "lat": 50.9375,
      "lng": 6.9603,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze.",
      "nearbyKey": "koeln"
    },
    {
      "name": "Langenfeld",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2014-07-01",
      "validFromDisplay": "01.07.2014",
      "aliases": [
        "Langenfeld Rheinland",
        "Langenfeld (Rheinland)"
      ],
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "type": "city",
      "lat": 51.1082,
      "lng": 6.9483,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Mönchengladbach",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2014-07-01",
      "validFromDisplay": "01.07.2014",
      "aliases": [
        "Moenchengladbach",
        "Monchengladbach"
      ],
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "type": "city",
      "lat": 51.1805,
      "lng": 6.4428,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Münster",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2015-01-01",
      "validFromDisplay": "01.01.2015",
      "aliases": [
        "Muenster",
        "Munster"
      ],
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "type": "city",
      "lat": 51.9607,
      "lng": 7.6261,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Neuss",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2014-07-01",
      "validFromDisplay": "01.07.2014",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 51.2042,
      "lng": 6.6879,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Overath",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2017-10-01",
      "validFromDisplay": "01.10.2017",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 50.9323,
      "lng": 7.2838,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Remscheid",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2014-07-01",
      "validFromDisplay": "01.07.2014",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 51.1787,
      "lng": 7.1897,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Ruhrgebiet",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2014-07-01",
      "validFromDisplay": "01.07.2014",
      "type": "area",
      "aliases": [
        "Bochum",
        "Bottrop",
        "Castrop-Rauxel",
        "Castrop Rauxel",
        "Dortmund",
        "Duisburg",
        "Essen",
        "Gelsenkirchen",
        "Gladbeck",
        "Herne",
        "Herten",
        "Mülheim",
        "Muelheim",
        "Mülheim an der Ruhr",
        "Muelheim an der Ruhr",
        "Oberhausen",
        "Recklinghausen",
        "Ruhr",
        "Ruhr area",
        "Ruhr region",
        "Ruhrgebiet",
        "Ruhrpott",
        "Ruhrgebied",
        "Zaglebie Ruhry",
        "Zagłębie Ruhry",
        "Poruri",
        "Porúří"
      ],
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "lat": 51.4556,
      "lng": 7.0116,
      "geoType": "region_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze.",
      "nearbyKey": "ruhrgebiet"
    },
    {
      "name": "Siegen",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2015-01-01",
      "validFromDisplay": "01.01.2015",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 50.8748,
      "lng": 8.0243,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Wuppertal",
      "state": "Nordrhein-Westfalen",
      "validFrom": "2014-07-01",
      "validFromDisplay": "01.07.2014",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 51.2562,
      "lng": 7.1508,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Leipzig",
      "state": "Sachsen",
      "validFrom": "2011-03-01",
      "validFromDisplay": "01.03.2011",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 51.3397,
      "lng": 12.3731,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Halle",
      "state": "Sachsen-Anhalt",
      "validFrom": "2013-01-01",
      "validFromDisplay": "01.01.2013",
      "aliases": [
        "Halle Saale",
        "Halle (Saale)"
      ],
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "type": "city",
      "lat": 51.4969,
      "lng": 11.9688,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    },
    {
      "name": "Magdeburg",
      "state": "Sachsen-Anhalt",
      "validFrom": "2013-01-01",
      "validFromDisplay": "01.01.2013",
      "status": "active",
      "badgeColor": "green",
      "badgeRequired": true,
      "hasZone": true,
      "country": "DE",
      "aliases": [],
      "type": "city",
      "lat": 52.1205,
      "lng": 11.6276,
      "geoType": "city_center",
      "geoNote": "Stadt-/Gebietsmittelpunkt für Entfernungs-Hinweise, nicht exakte Umweltzonengrenze."
    }
  ],
  "sourceUrl": "https://gis.uba.de/website/umweltzonen/index.php",
  "geoVersion": "V6.1.2"
};
